export default __webpack_public_path__ + "static/masw-logo-7f8b1dcb07005b58aff126d4605f4f79.png";